import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

/** @jsx jsx */
import { jsx } from '@emotion/core';
import { gridSize } from '@atlaskit/theme/constants';
import { multiply } from '@atlaskit/theme/math';
export default (function (_ref) {
  var tokens = _ref.tokens,
      props = _objectWithoutProperties(_ref, ["tokens"]);

  return jsx("span", _extends({
    css: {
      color: tokens.requiredIndicator.textColor.rest,
      paddingLeft: "".concat(multiply(gridSize, 0.25), "px;")
    }
  }, props));
});